import MenuIcon from "@mui/icons-material/Menu";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import TwitterIcon from "@mui/icons-material/Twitter";
import { useNavigate, NavLink, useLocation } from "react-router-dom";
import {
  AppBar,
  Box,
  Button,
  Container,
  IconButton,
  Menu,
  MenuItem,
  Toolbar,
  Typography,
} from "@mui/material";
import { useSnackbar } from "notistack";
import React, { useEffect, useRef, useState } from "react";
import { getProviderOrSigner } from "../utils";
import LinkList from "./LinkList";
import axios from "axios";
import { useAuthContext } from "../context/AuthContextProvider";
import { TitleText } from "../components/common/TitleText";
import { createUser } from "../api/users";
import { ethers } from "ethers";
import { useIdleTimer } from "react-idle-timer";
import { doc, getDoc } from "firebase/firestore";
import { firestore } from "../firebase";
import Web3Modal from "web3modal";
import WalletConnectProvider from "@walletconnect/web3-provider";

import { useWeb3Context } from "../context/UseWeb3Context";

const pages = [
  { title: "About", path: "/about-us" },
  // { title: "drops", path: "/drop" },
];

const Navbar = () => {
  const [anchorElNav, setAnchorElNav] = useState(null);
  const [openMenu, setOpenMenu] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const accountRef = useRef();
  const libraryRef = useRef();
  const { authToken, setAuthToken, setAuthAccount, setAuthLibrary } =
    useAuthContext();
  const { library, setMultiLibrary, account, setMultiAccount } =
    useWeb3Context();
  const [provider, setProvider] = useState();

  const [chainId, setChainId] = useState();

  const navigate = useNavigate();

  const location = useLocation();

  const [user, setUser] = useState();
  useEffect(() => {
    const getDocData = async () => {
      const docToProcess = await doc(firestore, "users", account);
      const user = await getDoc(docToProcess);
      setUser(user.data());
      // console.log({ docToProcess });
    };
    if (!(account === undefined)) {
      getDocData();
    }
  }, [account]);

  useEffect(() => {
    const hideElement = () => {
      const element = document.getElementsByClassName("navbar")[0];
      if (element && location.pathname == "/") {
        element.style.display = "none";
      } else {
        element.style.display = "flex";
      }
    };
    hideElement()
  }, [location]);

  const userSignIn = async (library, account) => {
    if (library && account) {
      const signer = getProviderOrSigner(library, account);
      const sign = await signer.signMessage(account);
      axios
        .post("login", { account: account, sign: sign })
        .then((response) => {
          if (response.status === 200 || response.status === 201) {
            const token = response.data.token;
            createUser({ account, sign })
              .then((response) => {})
              .catch((e) => {
                // console.log(e)
              });
            setAuthToken(token);
            enqueueSnackbar("Connected successfully...!!!", {
              variant: "success",
              autoHideDuration: 1500,
            });
          }
        })
        .catch((error) => {
          enqueueSnackbar(error.message, {
            variant: "error",
            autoHideDuration: 1500,
          });
          // console.log(error.message);
        });
    }
  };

  const providerOptions = {
    walletconnect: {
      package: WalletConnectProvider,
      options: {
        infuraId: process.env.REACT_APP_INFURA_ID,
      },
    },
  };
  const web3Modal = new Web3Modal({
    network: process.env.REACT_APP_INFURA_NETWORK,
    cacheProvider: true,
    providerOptions,
  });

  const mulitpleWallet = async () => {
    try {
      const provider = await web3Modal.connect();

      const library = new ethers.providers.Web3Provider(provider);

      const accounts = await library.listAccounts();
      const network = await library.getNetwork();

      setProvider(provider);
      setAuthLibrary(library);
      setMultiLibrary(library);
      if (accounts) {
        setAuthAccount(accounts[0]);
        setMultiAccount(accounts[0]);
      }
      setChainId(network.chainId);
    } catch (err) {
      console.log(err);
    }
  };

  const onIdle = () => {
    if (localStorage.getItem("auth-token")) {
      localStorage.removeItem("auth-token");
      setAuthToken("");
      enqueueSnackbar("You are logout because of inactivity...!!!", {
        variant: "error",
        autoHideDuration: 1500,
      });
    }
  };

  const { getTotalActiveTime } = useIdleTimer({
    onIdle,
    timeout: 900000,
    promptTimeout: 0,
    events: [
      "mousemove",
      "keydown",
      "wheel",
      "DOMMouseScroll",
      "mousewheel",
      "mousedown",
      "touchstart",
      "touchmove",
      "MSPointerDown",
      "MSPointerMove",
      "visibilitychange",
    ],
    immediateEvents: [],
    debounce: 0,
    throttle: 0,
    eventsThrottle: 200,
    element: document,
    startOnMount: true,
    startManually: false,
    stopOnIdle: false,
    crossTab: false,
    syncTimers: 0,
  });

  useEffect(() => {
    accountRef.current = account;
    libraryRef.current = library;
  }, [account, library]);

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };
  const logoutUser = async () => {
    await web3Modal.clearCachedProvider();
    setOpenMenu(false);
    localStorage.removeItem("auth-token");
    localStorage.removeItem("walletconnect");
    setAuthToken("");
    setProvider("");
    setAuthLibrary("");
    setMultiLibrary("");
    setAuthAccount("");
    setMultiAccount("");

    enqueueSnackbar("Logged out successfully...", {
      variant: "success",
      autoHideDuration: 1500,
    });
    if (provider?.close) {
      await provider.close();
      setProvider(null);
    }

    navigate("/");
  };

  const getAccountIcon = () => {
    if (account && authToken) {
      return (
        <Box>
          <AccountCircleOutlinedIcon
            onClick={() => {
              setOpenMenu(true);
            }}
            sx={{
              height: { md: "50px" },
              width: { md: "50px" },
              fontSize: "2.5rem",
              color: "white",
              cursor: "pointer",
            }}
          />
          <Menu
            open={openMenu}
            onClose={() => setOpenMenu(false)}
            anchorOrigin={{ vertical: "top", horizontal: "left" }}
            transformOrigin={{ vertical: "top", horizontal: "left" }}
            sx={{
              marginLeft: { md: "70%", xs: "60%" },
              marginTop: { md: "40px", xs: "35px" },
            }}
          >
            <MenuItem
              sx={{
                color: "black",
                textDecoration: "none",
              }}
              onClick={() => setOpenMenu(false)}
            >
              <NavLink
                style={{ textDecoration: "none", color: "black" }}
                to="/profile"
              >
                View Profile
              </NavLink>
            </MenuItem>
            {user?.type === "admin" && ( //need to compare user.type === 'Admin' then show this menuItem
              <MenuItem
                sx={{
                  color: "black",
                  textDecoration: "none",
                }}
                onClick={() => setOpenMenu(false)}
              >
                <NavLink
                  style={{ textDecoration: "none", color: "black" }}
                  to="/admin"
                  onClick={() => {}}
                >
                  Admin
                </NavLink>
              </MenuItem>
            )}

            <MenuItem onClick={logoutUser}>Logout</MenuItem>
          </Menu>
        </Box>
      );
    }

    if (!account) {
      return (
        <Button
          sx={{
            marginLeft: { md: "-8%", xs: "" },
          }}
          variant="contained"
          title={account}
          onClick={mulitpleWallet}
        >
          Connect
        </Button>
      );
    }

    return (
      <Button
        sx={{
          marginLeft: { md: "-13%", xs: "" },
        }}
        variant="contained"
        title={account}
        onClick={() => {
          userSignIn(library, account);
        }}
      >
        Authenticate
      </Button>
    );
  };

  return (
    <AppBar
      sx={{
        alignItems: "center",
      }}
      position="relative"
      className="navbar"
    >
      <Box sx={{ width: { md: "57%", xs: "100%" } }}>
        <Container maxWidth="xl" sx={{ height: { md: "146px" } }}>
          <Toolbar
            disableGutters
            sx={{ display: "flex", justifyContent: "space-around" }}
          >
            <TwitterIcon
              onClick={() => window.open("https://twitter.com/bigbeyond_space")}
              sx={{
                height: { md: "31px" },
                width: { md: "31px" },
                display: { md: "flex", xs: "none" },
                marginTop: "10px",
                cursor: "pointer",
              }}
            />
            <Box
              sx={{
                flexGrow: 1,
                display: { xs: "flex", md: "none" },
              }}
            >
              <IconButton
                size="large"
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleOpenNavMenu}
                color="inherit"
              >
                <MenuIcon />
              </IconButton>
              <Menu
                id="menu-appbar"
                anchorEl={anchorElNav}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "left",
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                open={Boolean(anchorElNav)}
                onClose={handleCloseNavMenu}
              >
                {pages.map((page, i) => (
                  <MenuItem key={i} onClick={handleCloseNavMenu}>
                    <LinkList page={page} textColor={"black"} />
                  </MenuItem>
                ))}
              </Menu>
            </Box>

            {/* <AdbIcon sx={{ display: { xs: "flex", md: "none" }, mr: 1 }} /> */}
            <TitleText
              variant="h5"
              noWrap
              component="a"
              href=""
              sx={{
                marginRight: "auto",
                marginLeft: account ? "auto" : "50px",
                display: { xs: "flex", md: "none" },
                flexGrow: 1,
                color: "inherit",
                textDecoration: "none",
              }}
            >
              big beyond
            </TitleText>
            <Box
              sx={{
                flexGrow: 1,
                display: { xs: "none", md: "flex" },
                justifyContent: "center",
                height: "14px",
              }}
            >
              {pages.map((page, i) => {
                return <LinkList key={i} textColor={"white"} page={page} />;
              })}
            </Box>
            {getAccountIcon()}
          </Toolbar>
          <Typography
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            {/* <AdbIcon sx={{ display: { xs: "none", md: "flex" }, mr: 1 }} /> */}

            <TitleText
              variant="h4"
              noWrap
              component="a"
              href="/"
              sx={{
                display: { xs: "none", md: "flex" },
                color: "inherit",
                textDecoration: "none",
                fontSize: "52px",
                textTransform: "lowercase",
                marginTop: "20px",
                fontFamily: "Bodoni Moda",
                fontWeight: 700,
              }}
            >
              Big Beyond
            </TitleText>
          </Typography>
        </Container>
        {/* <Button
          sx={{
            marginLeft: { md: "-13%", xs: "" },
          }}
          variant="contained"
          title={account}
          onClick={mulitpleWallet}
        >
          demo wallet Connect
        </Button> */}
      </Box>
    </AppBar>
  );
};

export default Navbar;
